import type React from 'react';

const ReceiptTextIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <path
      d="M3.5 1.5H3C1.5 1.5 1 2.395 1 3.5V4V11C1 11.415 1.47 11.65 1.8 11.4L2.655 10.76C2.855 10.61 3.135 10.63 3.315 10.81L4.145 11.645C4.34 11.84 4.66 11.84 4.855 11.645L5.695 10.805C5.87 10.63 6.15 10.61 6.345 10.76L7.2 11.4C7.53 11.645 8 11.41 8 11V2.5C8 1.95 8.45 1.5 9 1.5H3.5ZM5.625 7.375H3.375C3.17 7.375 3 7.205 3 7C3 6.795 3.17 6.625 3.375 6.625H5.625C5.83 6.625 6 6.795 6 7C6 7.205 5.83 7.375 5.625 7.375ZM6 5.375H3C2.795 5.375 2.625 5.205 2.625 5C2.625 4.795 2.795 4.625 3 4.625H6C6.205 4.625 6.375 4.795 6.375 5C6.375 5.205 6.205 5.375 6 5.375Z"
      fill="#1B6275"
    />
    <path
      d="M9.005 1.5V2.25C9.335 2.25 9.65 2.385 9.88 2.61C10.12 2.855 10.25 3.17 10.25 3.5V4.71C10.25 5.08 10.085 5.25 9.71 5.25H8.75V2.505C8.75 2.365 8.865 2.25 9.005 2.25V1.5ZM9.005 1.5C8.45 1.5 8 1.95 8 2.505V6H9.71C10.5 6 11 5.5 11 4.71V3.5C11 2.95 10.775 2.45 10.415 2.085C10.05 1.725 9.555 1.505 9.005 1.5C9.01 1.5 9.005 1.5 9.005 1.5Z"
      fill="#1B6275"
    />
  </svg>
);

export default ReceiptTextIcon;
